module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Import from which course?',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('body', {
    staticClass: "center items-center p-5 flex-grow"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('span', [_vm._v("\n        This will import all of the saved feedback templates from the course\n        you select. Any edits you make will not be reflected in the old\n        course, so you can change or delete any imported templates.\n      ")])]), _vm._v(" "), (_vm.courses.length) ? _c('div', {
    staticClass: "row no-margin pt3 center-xs courses-list"
  }, [_c('ul', _vm._l((_vm.courses), function(course, index) {
    return _c('li', {
      key: course.id,
      staticClass: "flex flex-nowrap items-center w-100",
      on: {
        "click": function($event) {
          return _vm.selectCourse(index)
        }
      }
    }, [_c('div', [_c('pl-checkbox', {
      attrs: {
        "value": course
      },
      on: {
        "change": function($event) {
          return _vm.selectedCourses()
        }
      },
      model: {
        value: (_vm.selectedCourses),
        callback: function($$v) {
          _vm.selectedCourses = $$v
        },
        expression: "selectedCourses"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      attrs: {
        "for": course.title,
        "title": course.title
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("truncate")(course.title, 26)) + "\n            ")])])])
  }), 0)]) : _c('div', {
    staticClass: "row no-margin pv3 center-xs f4 b"
  }, [_vm._v("\n      No saved feedback to import\n    ")])]), _vm._v(" "), _c('footer', {
    staticClass: "flex my-5 center items-center"
  }, [_c('button', {
    staticClass: "mx-5 px-10 py-2 w-40 hover:bg-gray-200 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold disabled:opacity-50",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": !_vm.selectedCourses.length
    },
    on: {
      "click": _vm.importFeedback
    }
  }, [_vm._v("\n      Import\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5595071c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/importSavedFeedbackModal.vue
// module id = 1375
// module chunks = 61